import React, { useState, useEffect } from "react";
import styles from "./styles/style.module.css";
import errorHandler from "../../../assets/utils/ErrorHandler";
import { submitWordGame } from "../../../assets/services/apiServices";
import FlaseSound from "../../../assets/Audio/lose.mp3";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { IoCheckmarkOutline } from "react-icons/io5";
import { IoCheckmarkDoneSharp } from "react-icons/io5";
import WordGameFinalizeDialog from "../alertContents/WordGameFinalizeDialog";
const EMPTY_GRID = Array(6)
  .fill("")
  .map(() => Array(5).fill({ char: "", status: "empty" }));

const GameBoard = ({ data, gameId }) => {
  const [grid, setGrid] = useState(EMPTY_GRID);
  const [currentRow, setCurrentRow] = useState(0);
  const [lodingSubmit, setLodingSubmit] = useState(false);
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const lossAudio = new Audio(FlaseSound);

  const navigate = useNavigate();

  const handleCloseDialog = () => {
    navigate(-1, { replace: true });
  };

  const submitWord = async (guessedWord) => {
    setLodingSubmit(true);
    try {
      const response = await submitWordGame(gameId, guessedWord);

      const { wordGameTicket, message, rightAnswer } = response.data;
      const newGrid = Array(6)
        .fill(null)
        .map((_, rowIndex) => {
          const word = wordGameTicket[`try${rowIndex + 1}Word`] || "";
          const statusList = wordGameTicket[`try${rowIndex + 1}Status`] || [];

          return Array(5)
            .fill(null)
            .map((_, colIndex) => {
              const char = word[colIndex] || "";
              const status = statusList[colIndex]?.status || "empty";
              return { char, status };
            });
        });
      setGrid(newGrid);

      setCurrentRow(Math.min(wordGameTicket.currentTry, 5));

      if (wordGameTicket.rightAnswer) {
        setDialogMessage(message);
        setOpenSuccessDialog(true);
      } else if (wordGameTicket.currentTry === 6 && !rightAnswer) {
        setDialogMessage(message);
        setOpenErrorDialog(true);
      } else {
        const soudMuted = JSON.parse(localStorage.getItem("soudMuted"));
        if (soudMuted) {
          lossAudio.play();
        }
      }
    } catch (err) {
      errorHandler(err);
    } finally {
      setLodingSubmit(false);
    }
  };

  const handleSubmit = () => {
    const currentRowCells = grid[currentRow];

    const isIncomplete = currentRowCells.some((cell) => cell.char === "");
    if (isIncomplete) {
      toast.error("کلمه باید کامل باشد!");
      return;
    }

    const currentWord = currentRowCells.map((cell) => cell.char).join("");
    submitWord(currentWord);
  };

  useEffect(() => {
    const firstInput = document.getElementById(`cell-${currentRow}-0`);
    firstInput?.focus();
  }, [currentRow]);

  useEffect(() => {
    if (!data) return;

    const filledGrid = Array(6)
      .fill(null)
      .map((_, rowIndex) => {
        const word = data[`try${rowIndex + 1}Word`] || "";
        const statusList = data[`try${rowIndex + 1}Status`] || [];

        return Array(5)
          .fill(null)
          .map((_, colIndex) => {
            const char = word[colIndex] || "";
            const status = statusList[colIndex]?.status || "empty";
            return { char, status };
          });
      });

    setGrid(filledGrid);
    setCurrentRow(Math.min(data.currentTry, 5));
  }, [data]);

  const handleInputChange = (char, rowIndex, colIndex) => {
    if (!/^[\u0600-\u06FF]$/.test(char)) return;

    const newGrid = [...grid];
    newGrid[rowIndex][colIndex] = { char, status: "pending" };
    setGrid(newGrid);

    if (colIndex < 4) {
      const nextInput = document.getElementById(
        `cell-${rowIndex}-${colIndex + 1}`
      );
      nextInput?.focus();
    }
  };

  const handleInputKeyDown = (e, rowIndex, colIndex) => {
    if (e.key === "Backspace") {
      const newGrid = [...grid];
      const currentRowArr = [...newGrid[rowIndex]];

      if (currentRowArr[colIndex].char !== "") {
        currentRowArr[colIndex] = { char: "", status: "empty" };
      } else if (colIndex > 0) {
        currentRowArr[colIndex - 1] = { char: "", status: "empty" };
        const prevInput = document.getElementById(
          `cell-${rowIndex}-${colIndex - 1}`
        );
        prevInput?.focus();
      }

      newGrid[rowIndex] = currentRowArr;
      setGrid(newGrid);
    }
  };

  return (
    <div className="pt-2 pb-4">
      {grid.map((row, rowIndex) => (
        <div
          key={rowIndex}
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 28,
          }}
        >
          {row.map((cell, colIndex) => (
            <div className={styles.cellContainer} key={colIndex}>
              <input
                id={`cell-${rowIndex}-${colIndex}`}
                type="text"
                className={styles.cellInput}
                maxLength={1}
                value={cell.char}
                onChange={(e) =>
                  handleInputChange(e.target.value, rowIndex, colIndex)
                }
                onKeyDown={(e) => handleInputKeyDown(e, rowIndex, colIndex)}
                disabled={rowIndex !== currentRow}
                style={{
                  width: 50,
                  height: 50,
                  textAlign: "center",
                  margin: 2,
                  fontSize: "24px",
                  fontWeight: "bold",
                  backgroundColor: getColor(cell.status).backGround,
                  color: rowIndex !== currentRow ? "white" : "",
                  opacity: rowIndex > currentRow ? 0.4 : 1,
                  border: "none",
                  borderRadius: "10px",
                  borderBottom: `5px solid ${getColor(cell.status).border}`,
                  direction: "rtl",
                  outline: "none",
                }}
              />
              <div className={styles.cellIconContainer}>
                {cell.status === "present" && (
                  <IoCheckmarkOutline fontSize={12} />
                )}
                {cell.status === "correct" && (
                  <IoCheckmarkDoneSharp fontSize={12} />
                )}
              </div>
            </div>
          ))}
        </div>
      ))}
      <button
        className={`${styles.wordGameButton} ${styles.orangeButton}`}
        onClick={handleSubmit}
        disabled={lodingSubmit}
      >
        {lodingSubmit ? "در حال بررسی" : "بررسی پاسخ"}
      </button>
      <WordGameFinalizeDialog
        open={openSuccessDialog || openErrorDialog}
        handleClose={handleCloseDialog}
        message={dialogMessage}
        type={openSuccessDialog ? "correct" : "wrong"}
      />
    </div>
  );
};

const getColor = (status) => {
  switch (status) {
    case "correct":
      return { backGround: "#12D18E", border: "#00B777" };
    case "present":
      return { backGround: "#F68908", border: "#F48400" };
    case "absent":
      return { backGround: "#F75555", border: "#EA1E61" };
    default:
      return { backGround: "#CCCCCC", border: "#B1B1B1" };
  }
};

export default GameBoard;
